import { useEffect } from 'react';
import Select, { StylesConfig, CSSObjectWithLabel } from 'react-select';

interface CreditNoteItem {
  credit_note_status_id: number;
  credit_note_status_name: string;
  label?: string;
  value?: number;
  [key: string]: any;
}

interface CreditNoteOptionsProps {
  bulkActionData: any[];
  onFilterSelect: (val: any | null) => void;
  defaultVal?: CreditNoteItem | null;
}

const customStyles: StylesConfig<CreditNoteItem, false> = {
  control: (provided, state) =>
    ({
      ...provided,
      height: 45,
      backgroundColor: '#fff',
      width: 200,
    } as CSSObjectWithLabel),
  indicatorSeparator: (provided, state) =>
    ({
      ...provided,
      display: 'none',
    } as CSSObjectWithLabel),
  valueContainer: (provided, state) =>
    ({
      ...provided,
      height: 20,
      paddingBottom: '45px',
      marginLeft: '13px',
    } as CSSObjectWithLabel),
  option: (provided, state) =>
    ({
      ...provided,
      backgroundColor: state.isSelected ? '#f1f1f1' : '#fff',
      color: 'black',
    } as CSSObjectWithLabel),
};

const CreditNoteOptions: React.FC<CreditNoteOptionsProps> = ({ bulkActionData, onFilterSelect, defaultVal }) => {
  useEffect(() => {}, [bulkActionData]);

  const customOption = bulkActionData
    ?.filter(item => item.credit_note_status_id !== 0)
    .map(item => ({
      ...item,
      label: item.credit_note_status_name,
      value: item.credit_note_status_id,
    }));

  return (
    <Select
      styles={customStyles}
      onChange={val => onFilterSelect(val as CreditNoteItem | null)}
      defaultValue={defaultVal}
      placeholder="Change Status"
      options={customOption}
    />
  );
};

export default CreditNoteOptions;
